<template>
    <div class='info-box'>
        <div class="iframe-box">
            <iframe id="ifra"
                    src="https://bim.zhuxingyun.com/viewer?id=8309be80d6584d07965c7deb8d46ce29&title="></iframe>
        </div>

        <!--        基本信息-->
        <div class="base-info">
            <el-title title="基础信息"></el-title>
            <div class="baseList-box">
                <div class="baseList-item" :class="{'single-bg':bSingle(index)}" v-for="(item,index) in baseList"
                     :key="index">
                    <div>{{ item.attr_name }}</div>
                    <div>{{ item.attr_value }}</div>
                </div>
            </div>
        </div>

        <!--        勘察汇总-->
        <div class="survey-sum">
            <el-title title="勘察汇总"></el-title>
            <div class="survey-data-box">
                <div class="survey-item" v-for="(item,index) in surveyData" :key="index">
                    <div>{{ item.attr_name }}</div>
                    <div>{{ item.attr_value }}</div>
                </div>
            </div>
        </div>

        <!--        区域信息-->
        <div class="survey-area">
            <el-title title="区域信息"></el-title>
            <div class="survey-area-table">
                <div class="survey-area-left">
                    <div class="thead-info flc2">区域</div>
                    <div class="theader flc2">房间</div>
                    <div class="survey-left-list">
                        <div class="survey-left-item flc2" v-for="(item,index) in areaLeft" :key="index">
                            {{ item.name }}
                            <img src="@/assets/images/archives/dossier/downselect.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="survey-area-right">
                    <div class="absolute-box">
                        <div class="thead-info flc2">
                            <div class="thead-info-content flc2">房屋勘察信息</div>
                            <div class="thead-info-content nopadding flc2">推荐安装设备</div>
                        </div>
                        <div class="theader flc2">
                            <div v-for="(item,index) in theaderList" :key="index" class="theader-content">
                                <div v-for="(item2,index2) in item" :key="index2" class="flc"
                                     :ref="'theaderRef' + showIndex(index,index2)">
                                    <span>{{ item2.name }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="survey-right-list">
                            <div class="survey-item-box" v-for="(item,index) in areaRight" :key="index"
                                 :class="{'gray-bg': index % 2 != 1}">
                                <div class="survey-item-value flc" v-for="(item2,index2) in item"
                                     :style="{width:widthList[index2] + 'px'}">
                                    <span>
                                        {{ item2.value }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import elTitle from './title'

export default {
    name: "info",

    // 组件注册
    components: {
        elTitle
    },
    data() {
        return {
            bIframe: false,// 控制iframe显示隐藏
            baseList: [
                {
                    attr_name: '房屋类型',
                    attr_value: '别墅',
                }, {
                    attr_name: '装修情况',
                    attr_value: '毛坯房',
                }, {
                    attr_name: '房屋保温',
                    attr_value: '良好',
                }, {
                    attr_name: '房屋层高',
                    attr_value: '3m',
                }, {
                    attr_name: '燃气配置',
                    attr_value: '4.0',
                }, {
                    attr_name: '水压大小',
                    attr_value: '大于1bar',
                }, {
                    attr_name: '系统需求',
                    attr_value: '冷暖 新风',
                }, {
                    attr_name: '常住人口',
                    attr_value: '5人',
                }, {
                    attr_name: '常住人口',
                    attr_value: '5人',
                }
            ], // 基础信息
            surveyData: [
                {
                    attr_name: '空调总面积',
                    attr_value: '90㎡',
                }, {
                    attr_name: '地暖总面积',
                    attr_value: '90㎡',
                }, {
                    attr_name: '新风总面积',
                    attr_value: '110㎡',
                }, {
                    attr_name: '封盘总数量',
                    attr_value: '1',
                }, {
                    attr_name: '散热片总数量',
                    attr_value: '1',
                }, {
                    attr_name: '新风风口总数量',
                    attr_value: '1',
                }
            ], // 勘察信息
            areaLeft: [
                {
                    name: '主卧',
                },
                {
                    name: '老人房间',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }, {
                    name: '主卧',
                }
            ],// 区域信息左边内容
            areaRight: [
                [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }],
                [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }], [{
                    value: '22㎡'
                }, {
                    value: '南'
                }, {
                    value: '3m'
                }, {
                    value: '2'
                }, {
                    value: '地暖'
                }, {
                    value: '风'
                }],
            ], // 区域信息右边内容
            theaderList: [
                [{
                    name: '面积',
                }, {
                    name: '朝向',
                }, {
                    name: '层高',
                }], [
                    {
                        name: '风盘',
                    }, {
                        name: '地暖/散热风',
                    }, {
                        name: '新风风口',
                    }
                ]
            ],// 表头
            widthList: [],//表头宽度列表
        };
    },
    props: {},
    //计算属性
    computed: {
        bSingle(index) {
            return index => {
                return Math.ceil((index + 1) / 3) % 2 != 0
            }
        },
        showIndex(index1, index2) {
            return (index1, index2) => {
                return index1 * this.theaderList[0].length + index2
            }
        },
        computedNum() {
            let num = 0
            this.theaderList.forEach(ele => {
                num += ele.length
            })
            return num
        }
    },
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        // 判断iframe是否加载完成
        bIframeLoad() {
            let _this = this
            const iframe = document.querySelector('#ifra')
            // 处理兼容行问题 兼容IE
            if (iframe.attachEvent) {
                iframe.attachEvent('onerror', function () {
                    // iframe加载完毕以后执行操作
                    console.log('iframe已加载完毕')
                    _this.iframeloading = false
                })
            } else {
                iframe.onerror = function () {
                    // iframe加载完毕以后执行操作
                    console.log('iframe已加载完毕')
                    _this.iframeloading = false
                }
            }
        },
    },
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
        // 获取元素高度
        for (let i = 0; i < this.computedNum; i++) {
            let ref = 'theaderRef' + i
            let width = this.$refs[ref][0].offsetWidth
            this.widthList.push(width)
        }
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.info-box {
    width: 100%;
    height: 100%;
    padding-bottom: env(safe-area-inset-bottom);

    .iframe-box {
        width: 100%;
        height: 752px;
        margin-bottom: 16px;
        //background: #D8D8D8;
        iframe {
            width: 100%;
            height: 100%;
        }
    }

    .base-info {
        //height: 494px;
        background: #FFFFFF;
        padding-bottom: 32px;
        border-radius: 16px 16px 16px 16px;
        margin-bottom: 16px;

        .baseList-box {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;

            .baseList-item {
                height: 116px;
                padding: 16px 0 0 48px;

                div:nth-child(1) {
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                    margin-bottom: 8px;
                }

                div:nth-child(2) {
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                }
            }

            .single-bg {
                background: #F9F9FB;
            }
        }
    }

    .survey-sum {
        background: #FFFFFF;
        padding-bottom: 32px;
        border-radius: 16px 16px 16px 16px;
        margin-bottom: 16px;

        .survey-data-box {
            padding: 48px 0;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            background: #F9F9FB;

            .survey-item {
                height: 92px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                div:nth-child(1) {
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                    padding-left: 32px;
                }

                div:nth-child(2) {
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 32px;
                    border-right: 1px solid #DDDDDD;
                }

                &:nth-child(3n) {
                    div:nth-child(2) {
                        border-right: none;
                    }
                }
            }
        }
    }

    .survey-area {
        background: #FFFFFF;
        padding-bottom: 32px;
        border-radius: 16px 16px 16px 16px;
        margin-bottom: 16px;

        .survey-area-table {
            display: flex;
            border-bottom: 2px #000 solid;

            .survey-area-left {
                width: 204px;

                .thead-info {
                    box-sizing: border-box;
                    height: 80px;
                    padding-left: 50px;
                }

                .theader {
                    padding: 20px 0 20px 50px;
                    border-top: 2px solid #000000;
                    border-right: 2px solid #000000;
                    font-size: 20px;
                    font-weight: 500;
                    color: #333333;
                    background-color: #f9f9fb;
                }

                .survey-left-list {
                    background-color: #f9f9fb;

                    .survey-left-item {
                        font-size: 26px;
                        font-weight: 400;
                        color: #3D3C4F;
                        height: 80px;
                        padding-left: 50px;
                        border-right: 2px solid #000000;
                        position: relative;

                        img {
                            width: 24px;
                            height: 24px;
                            position: absolute;
                            right: 20px;
                        }
                    }
                }
            }

            .survey-area-right {
                overflow-y: hidden;
                overflow-x: scroll;
                position: relative;
                flex: 1;

                .absolute-box {
                    position: absolute;
                    left: 0;
                    top: 0;
                    min-width: calc(100vw - 204px);
                }

                .thead-info {
                    display: flex;

                    .thead-info-content {
                        width: calc(50% - 8px);
                        height: 80px;
                        padding-left: 32px;
                    }

                    .nopadding {
                        padding-left: 0;
                    }
                }

                .theader {
                    border-top: solid 2px #000;
                    box-sizing: border-box;
                    padding: 20px 0;
                    display: flex;

                    .theader-content {
                        border-right: solid 2px #000;
                        white-space: nowrap;
                        font-size: 20px;
                        font-weight: 500;
                        color: #333333;

                        div {
                            display: inline-flex;
                            min-width: 100px;
                            padding: 0 20px;
                        }

                        &:last-child {
                            border: none;
                        }
                    }
                }

                .survey-right-list {
                    .survey-item-box {
                        white-space: nowrap;

                        .survey-item-value {
                            display: inline-flex;
                            align-items: center;
                            height: 80px;
                            box-sizing: border-box;
                            //margin-top: -2px;
                            font-size: 26px;
                            font-weight: 400;
                            color: #999999;

                            &:nth-child(3) {
                                span {
                                    width: 100%;
                                    display: inline-block;
                                    text-align: center;
                                    border-right: #000 solid 2px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.gray-bg {
    background-color: #f9f9fb;
}
</style>
